import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "../../_App/Redux/hooks";
import { SelectedOrganisationId } from "../../_App/Redux/Slices/Auth/authSlice";
import {
  findCheques,
  findVirements,
  listCheques,
  Virements,
} from "../../_App/Redux/Slices/payments/PaymentSlice";
import Swal from "sweetalert2";
import Navbar from "../../_Layouts/Navbar/Navbar";
import ChequesTable from "../../Components/Caisses/Payment/ChequeTable";
import VirementTable from "../../Components/Caisses/Payment/VirementTable";

const VirementsPage = () => {
  const { t } = useTranslation();

  const dispatch = useAppDispatch();
  const currentOrg = useAppSelector(SelectedOrganisationId);
  const cheques = useAppSelector(Virements);

  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (currentOrg) {
      dispatch(findVirements(currentOrg));
    }
  }, [dispatch]);

  const verifcationMsg = (msg: string) => {
    return Swal.fire({
      title: t("vous-êtes sûr?"),
      text: msg,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: t("Confirmer!"),
      cancelButtonText: t("Cancel!"),
    }).then((result) => {
      return result.isConfirmed ? true : false;
    });
  };

  return (
    <div>
      {cheques && cheques.length !== 0 ? (
        <VirementTable />
      ) : (
        <p>aucun virement</p>
      )}
    </div>
  );
};

export default VirementsPage;
